<template>
  <div class="faq-list">
    <div v-for="(item, index) in currentFaqs" :key="index" class="faq-item" :class="{ active: item.isOpen }">
      <div class="question" @click="toggleItem(index)">
        {{ item.q }}
        <span class="arrow-icon">{{ item.isOpen ? '▲' : '▼' }}</span>
      </div>
      <div class="answer" v-show="item.isOpen">
        {{ item.a }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeTab: { type: String, required: true }
  },
  data() {
    return {
      // 为每个 Tab 配置完全独立的列表内容
      allFaqs: {
        'General': [
          { q: "What is Fraud Counsel Department and what do you actually do?", a: "We review cases involving cryptocurrency loss — scams, phishing, lost wallet access, and exchange lockouts — and help you understand what happened, what your realistic options are, and what documentation or next steps might help.", isOpen: false },
          { q: "Can you guarantee you'll recover my lost cryptocurrency?", a: "No legitimate firm can guarantee recovery, as it depends on blockchain forensics, regulatory cooperation, and the nature of the crime.", isOpen: false },
          { q: "What types of crypto loss cases do you handle?", a: "We handle cases involving investment scams, romance scams, hacked accounts, rug pulls, fraudulent exchanges, and private key loss.", isOpen: false },
          { q: "How do I know Fraud Counsel Department is legitimate and not another scam?", a: "We are a government-certified firm. Our team consists of former law enforcement officers and forensic accountants.", isOpen: false }
        ],
        'Recovery': [
          { q: "How long does the crypto recovery process usually take?", a: "Simple cases can take a few weeks, while more complex cross-chain investigations may take several months depending on the exchange's compliance response time.", isOpen: false },
          { q: "Do you work with international law enforcement?", a: "Yes, we have established connections with cybercrime units in multiple jurisdictions globally to aid in the seizure of stolen assets.", isOpen: false }
        ],
        'Process': [
          { q: "What is the first step you take when I hire you?", a: "We begin with a comprehensive forensic analysis of the blockchain to trace the path of your stolen funds, identifying the receiving wallets and exchanges.", isOpen: false },
          { q: "Will I need to provide my private keys?", a: "Absolutely not. We never require your private keys or seed phrases. This ensures your funds remain completely secure with you.", isOpen: false }
        ],
        'Fees & Security': [
          { q: "How are your fees structured?", a: "We charge an initial assessment fee, followed by a percentage of the recovered funds only upon a successful recovery. No hidden charges.", isOpen: false },
          { q: "How do you protect my personal data?", a: "All client data is encrypted using military-grade AES-256 encryption and stored on secure, air-gapped servers.", isOpen: false }
        ],
        'Getting Started': [
          { q: "What information do you need to start my case?", a: "You'll need to provide your wallet address(es), transaction hashes (TXIDs), screenshots of communications with the scammers, and any KYC details used on the fraudulent platform.", isOpen: false },
          { q: "Is there a minimum amount required to take a case?", a: "Yes, cases typically need to involve losses exceeding $1,000 to make the forensic process economically viable for our team.", isOpen: false }
        ]
      }
    };
  },
  computed: {
    // 根据传入的 activeTab 动态返回对应的列表
    currentFaqs() {
      return this.allFaqs[this.activeTab] || [];
    }
  },
  methods: {
    toggleItem(index) {
      // 直接修改返回对象的引用属性，保持 Vue2 的响应式
      this.currentFaqs[index].isOpen = !this.currentFaqs[index].isOpen;
    }
  }
}
</script>

<style scoped>
.faq-list {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 5% 100px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.faq-item {
  background: #0d1117;
  border: 1px solid #233045;
  border-radius: 8px;
  padding: 25px 30px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.faq-item.active {
  border: 1px solid #2ee6a8;
  background: #101826;
  box-shadow: 0 0 20px rgba(46, 230, 168, 0.1);
}

.question {
  font-size: 1rem;
  font-weight: 600;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.arrow-icon {
  font-size: 0.8rem;
  color: #2ee6a8;
  transition: transform 0.3s ease;
}

.answer {
  font-size: 0.9rem;
  color: #a0b3cc;
  line-height: 1.7;
  margin-top: 20px;
  border-top: 1px solid rgba(46, 230, 168, 0.2);
  padding-top: 20px;
}

@media (max-width: 768px) {
  .faq-item {
    padding: 20px;
  }

  .question {
    font-size: 1.1rem;
  }

  .answer {
    font-size: 0.95rem;
  }
}
</style>